import { useState, useEffect, useCallback } from 'react';

export const useAnimations = () => {
  const [animatingItems, setAnimatingItems] = useState(new Map());
  const [showSuccess, setShowSuccess] = useState(false);

  // Add animation class to a specific item
  const addAnimation = useCallback((itemId, animationClass, duration = 1000) => {
    setAnimatingItems(prev => new Map(prev).set(itemId, animationClass));
    
    setTimeout(() => {
      setAnimatingItems(prev => {
        const newMap = new Map(prev);
        newMap.delete(itemId);
        return newMap;
      });
    }, duration);
  }, []);

  // Show success checkmark
  const showSuccessAnimation = useCallback(() => {
    setShowSuccess(true);
    setTimeout(() => setShowSuccess(false), 600);
  }, []);

  // Get animation class for a specific item
  const getAnimationClass = useCallback((itemId) => {
    return animatingItems.get(itemId) || '';
  }, [animatingItems]);

  // Clear all animations
  const clearAnimations = useCallback(() => {
    setAnimatingItems(new Map());
  }, []);

  return {
    addAnimation,
    showSuccessAnimation,
    getAnimationClass,
    clearAnimations,
    showSuccess
  };
};